import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import OutCli2Img from '@/assets/out-cli2.svg?react';
import OutCli3Img from '@/assets/out-cli3.svg?react';
import OutCli4Img from '@/assets/out-cli4.svg?react';

import css from './index.module.less';

export function FeaturesSection() {
  const { t } = useTranslation();

  const FEATURES = [
    {
      title: t('cli.features.card1.title'),
      description: t('cli.features.card1.description'),
      image: OutCli2Img,
    },
    {
      title: t('cli.features.card2.title'),
      description: t('cli.features.card2.description'),
      image: OutCli3Img,
    },
    {
      title: t('cli.features.card3.title'),
      description: t('cli.features.card3.description'),
      image: OutCli4Img,
    },
  ];
  return (
    <div
      className={clsx(
        css['features-container'],
        'flex flex-col md:flex-row md:flex-wrap xl:flex-row xl:flex-nowrap',
      )}
    >
      {FEATURES.map((feature, index) => (
        <div key={index} className={clsx(css['feature-card'])}>
          <div className={clsx(css['feature-text'])}>
            <h3 className={clsx(css['feature-title'])}>{feature.title}</h3>
            <p className={clsx(css['feature-description'])}>{feature.description}</p>
          </div>
          <feature.image className={clsx(css['feature-image'])} />
          {/* <img
            src={feature.image}
            alt={feature.title}
            className={clsx(
              css['feature-image'])}
          /> */}
        </div>
      ))}
    </div>
  );
}
